import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { InsideSection } from '../components/sales/InsideSection';
import { PainSection } from '../components/sales/PainSection';
import { SolutionSection } from '../components/sales/SolutionSection';
import { VolumesSection } from '../components/sales/VolumesSection';
import { BonusesSection } from '../components/sales/BonusesSection';
import { BeforeAfterSection } from '../components/sales/BeforeAfterSection';
import { AudienceSection } from '../components/sales/AudienceSection';
import { OfferSection } from '../components/sales/OfferSection';
import { HowItWorksSection } from '../components/sales/HowItWorksSection';
import { FaqSection } from '../components/sales/FaqSection';
import { FinalSection } from '../components/sales/FinalSection';
import { SiteFooter } from '../components/sales/SiteFooter';
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-ivory font-body text-brand-charcoal" data-id="element-201" data-mp="3vmi5nliu4poy">
      <header className="border-b border-brand-charcoal/10 bg-brand-paper" data-id="element-202" data-mp="3akrv1q7tia2s">
        <div className="mx-auto flex max-w-6xl items-center justify-center px-5 py-3 lg:px-8" data-id="element-203" data-mp="35shyhrc76brj">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-charcoal" data-id="element-204" data-mp="30tneim2huh5u">
            Hair Extension Instructor Ready™ · by Prof. Kyra
          </p>
        </div>
      </header>

      <main data-id="element-205" data-mp="3tiue7odopcso">
        <HeroSection data-id="element-206" data-mp="3thjbzszw0d3o" />
        <InsideSection data-id="element-207" data-mp="3tht3jl0kysbh" />
        <PainSection data-id="element-208" data-mp="3tg87ts2j53c1" />
        <SolutionSection data-id="element-209" data-mp="3oizoho5nat97" />
        <VolumesSection data-id="element-210" data-mp="3okj2f83tws7t" />
        <BonusesSection data-id="element-211" data-mp="3okap5f3snkw3" />
        <BeforeAfterSection data-id="element-212" data-mp="3jken3lenq3j6" />
        <AudienceSection data-id="element-213" data-mp="3jjn0v16y9i5k" />
        <OfferSection data-id="element-214" data-mp="3jitqzrcp2cj7" />
        <HowItWorksSection data-id="element-215" data-mp="3jmhlottvl4zi" />
        <FaqSection data-id="element-216" data-mp="3fj33bwigsciw" />
        <FinalSection data-id="element-217" data-mp="3fhrq7634psf4" />
      </main>

      <SiteFooter data-id="element-218" data-mp="3fijjubd61g2r" />
    </div>;
}